import React from "react";
import { Play, Pause, SkipForward } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { DEFAULT_COVER } from "@/lib/format";

export function MiniPlayer() {
  const { currentSong, isPlaying, togglePlay, playNext, progress, duration, setFullOpen } = useApp();
  if (!currentSong) return null;
  const pct = duration ? (progress / duration) * 100 : 0;

  return (
    <div data-testid="mini-player" className="mx-2 mb-1 rounded-2xl overflow-hidden backdrop-blur-2xl bg-black/55 border border-white/10 shadow-2xl shadow-black/50">
      <div className="h-1 w-full bg-white/10">
        <div className="h-full bg-[#ff3366] transition-[width] duration-300" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center gap-3 px-3 py-2">
        <button data-testid="mini-open-full" onClick={() => setFullOpen(true)} className="flex items-center gap-3 min-w-0 flex-1 text-left">
          <img src={currentSong.cover || DEFAULT_COVER} alt="" className={`h-11 w-11 rounded-lg object-cover shadow-lg ${isPlaying ? "animate-spin-slow" : ""}`} style={{ borderRadius: isPlaying ? "50%" : "0.5rem" }} />
          <div className="min-w-0">
            <p className="truncate font-medium text-sm">{currentSong.title}</p>
            <p className="truncate text-xs text-white/50">{currentSong.artist}</p>
          </div>
        </button>
        <button data-testid="mini-play-btn" aria-label="play" onClick={togglePlay} className="h-10 w-10 grid place-items-center rounded-full bg-white text-black shrink-0 active:scale-95 transition-transform">
          {isPlaying ? <Pause className="h-5 w-5" fill="black" /> : <Play className="h-5 w-5 ml-0.5" fill="black" />}
        </button>
        <button data-testid="mini-next-btn" aria-label="next" onClick={playNext} className="h-10 w-10 grid place-items-center rounded-full text-white/70 hover:text-white shrink-0">
          <SkipForward className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
